import { render, staticRenderFns } from "./ApplicantsData.vue?vue&type=template&id=74fb72bb&scoped=true"
import script from "./ApplicantsData.vue?vue&type=script&lang=js"
export * from "./ApplicantsData.vue?vue&type=script&lang=js"
import style0 from "./ApplicantsData.vue?vue&type=style&index=0&id=74fb72bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fb72bb",
  null
  
)

export default component.exports